import { Component, OnInit } from '@angular/core';
import { Subject, Subscription, filter, mergeMap, noop, of, tap } from 'rxjs';
import { MessageService } from 'primeng/api';
import { StoreChangesService } from 'projects/shared/services/store-changes.service';
import { SideMenuService } from '../layout/side-menu/services/side-menu.service';
import { UserService } from 'projects/shared/services/user.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  loginMessageAfter!: string;
  endsubs$: Subject<any> = new Subject();

  topUpOrdersCount: any = 0;
  topUpProcessingCount = 0;

  ordersCount: any = 0;
  orderProcessingCount = 0;

  userCounts = 0;

  ticketCounts!: ({open: number, closed: number})

  private _subscription = new Subscription();

  constructor(
    private _messageService: MessageService,
    private _storeChangesServ: StoreChangesService,
    private _sideMenuService: SideMenuService,
    private _userService: UserService
  ) { }

  ngOnInit(): void {
    this.loginMessage();
    this.getTopUpOrdersCount();
    this.getOrdersCount();
    this.getUsersCount();
    this.getTicketCount()
  }

  ngAfterViewInit(): void {
    if (this.loginMessageAfter != '') {
      this._messageService.add({ severity: 'success', summary: 'Success', detail: this.loginMessageAfter });
    }
  }

  getUsersCount() {
    this._subscription.add(
      this._userService.getAllUsers({page: 1, limit: 1}).pipe(
        mergeMap(count => of(count.total)),
        tap(
          res => {
            this.userCounts = res;
          }
        )
      ).subscribe(noop)
    )
  }

  getTopUpOrdersCount() {
    this._sideMenuService.topUpsCount_BS.pipe(
      filter(count => !!count),
      tap(
        count => {
          this.topUpProcessingCount = count?.['Processing']
          this.topUpOrdersCount = Object.values(count).reduce((sum: any, count: any) => sum + count, 0);;
        }
      )
    ).subscribe(noop)
  }

  getOrdersCount() {
    this._sideMenuService.orderCount_BS.pipe(
      filter(count => !!count),
      tap(
        count => {
          this.orderProcessingCount = count
          this.ordersCount = count.reduce((total: number, item: any) => {
            if (item._id?.toLowerCase() === 'processing') {
              this.orderProcessingCount = item.count;
            }
            return total + item.count;
          }, 0);
        }
      )
    ).subscribe(noop)
  }

  getTicketCount() {
    this._subscription.add(
      this._sideMenuService.ticketCount_BS.pipe(
        filter( count => !!count),
        tap(
          count => {
            this.ticketCounts = count;
          }
        )
      ).subscribe(noop)
    )
  }

  loginMessage() {
    this._storeChangesServ.getloginMessage().subscribe(res => {
      this.loginMessageAfter = res
    });
  }



}
